export default interface IReCAPTCHA {
  render: (
    container: HTMLElement | string,
    parameters: IReCAPTCHAParams
  ) => string;
  execute: (id?: string) => void;
  reset: (id?: string) => void;
  getResponse: (id?: string) => string;
}

export interface IReCAPTCHAParams {
  sitekey: string;
  badge?: "bottomright" | "bottomleft" | "inline" | "bottomright";
  size?: "invisible";
  tabindex?: number;
  callback?: (token: string) => void | string;
  "expired-callback"?: (token: string) => void | string;
  "error-callback"?: (token: string) => void | string;
}

export const defaultReCAPTCHA = {
  getResponse: () => "",
  render: () => "0",
  execute: () => {},
  reset: () => {},
};
